/* Arabesk theme scripts */
(function () {
  'use strict';
  var A = window.arabesk || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = (format || A.moneyFormat || '{{amount}}').replace(/<[^>]*>/g, '');
    function withDelimiters(n, precision, thousands, decimal) {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    document.querySelectorAll('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusable = d.querySelector('.drawer__panel button, .drawer__panel a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!document.querySelector('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
      var sb = document.getElementById('SearchBar');
      if (sb && !sb.hidden) toggleSearch(false);
    }
  });

  /* ---------- Search bar ---------- */
  function toggleSearch(force) {
    var bar = document.getElementById('SearchBar');
    var btn = document.querySelector('[data-search-toggle]');
    if (!bar) return;
    var show = typeof force === 'boolean' ? force : bar.hidden;
    bar.hidden = !show;
    if (btn) btn.setAttribute('aria-expanded', String(show));
    if (show) { var input = bar.querySelector('input[type="search"]'); if (input) input.focus(); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-toggle]')) { e.preventDefault(); toggleSearch(); }
  });

  /* ---------- Announcement rotator ---------- */
  document.querySelectorAll('[data-rotator]').forEach(function (el) {
    var msgs = el.querySelectorAll('.announcement__msg');
    if (msgs.length < 2 || reduceMotion) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, parseInt(el.dataset.interval, 10) || 4000);
  });

  /* ---------- Hero slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (el) {
    var slides = el.querySelectorAll('.hero__slide');
    var dots = el.querySelectorAll('.hero__dot');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    function go(n) {
      slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
    }
    function start() {
      if (el.dataset.autoplay !== 'true' || reduceMotion) return;
      stop(); timer = setInterval(function () { go(i + 1); }, parseInt(el.dataset.interval, 10) || 6000);
    }
    function stop() { if (timer) clearInterval(timer); }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.slideTo, 10)); start(); }); });
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); start(); }
      x0 = null;
    });
    start();
  });

  /* ---------- Autosubmit (filters, sort, localization) ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  /* ---------- Cart ---------- */
  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }
  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-inner]');
    var current = document.querySelector('[data-cart-drawer-inner]');
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCount(parseInt(fresh.dataset.count, 10) || 0);
    }
  }
  function useDrawer() { return A.cartType === 'drawer' && document.getElementById('CartDrawer'); }

  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && useDrawer()) { e.preventDefault(); openDrawer('CartDrawer'); }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var item = btn.closest('[data-line]');
    var inner = btn.closest('[data-cart-drawer-inner]');
    if (!item) return;
    if (inner) inner.classList.add('is-loading');
    fetch(A.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(item.dataset.line, 10), quantity: parseInt(btn.dataset.qtyChange, 10), sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections) renderDrawer(data.sections['cart-drawer']);
        else window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  });

  /* ---------- Product page ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-button]');
    var addText = root.querySelector('[data-add-text]');
    var priceWrap = root.querySelector('[data-price-wrap]');
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    var mediaList = root.querySelector('[data-media-list]');
    var dots = root.querySelectorAll('.product__dot');
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var errorEl = root.querySelector('[data-form-error]');

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function markAvailability(opts) {
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice(); test[i] = input.value;
          var m = findVariant(test);
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !m || !m.available);
        });
      });
    }
    function renderPrice(v) {
      if (!priceWrap) return;
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      priceWrap.innerHTML = '<div class="price' + (sale ? ' price--sale' : '') + '">' +
        '<span class="price__current">' + formatMoney(v.price) + '</span>' +
        (sale ? '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' : '') + '</div>';
    }
    function showMedia(v) {
      if (!mediaList || !v.featured_media) return;
      var el = mediaList.querySelector('[data-media-id="' + v.featured_media.id + '"]');
      if (!el) return;
      if (window.matchMedia('(min-width: 990px)').matches) {
        mediaList.prepend(el);
      } else {
        mediaList.scrollTo({ left: el.offsetLeft - mediaList.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }
    function update(fromUser) {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var label = fs.querySelector('[data-option-selected]');
        if (label) label.textContent = opts[i] || '';
      });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!addBtn) return;
      if (!v) {
        addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? 'Add to bag' : 'Sold out';
      renderPrice(v);
      if (fromUser) {
        showMedia(v);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    // Initialise from the current variant
    if (idInput && variants.length) {
      var current = variants.find(function (v) { return String(v.id) === String(idInput.value); });
      if (current) {
        fieldsets.forEach(function (fs, i) {
          fs.querySelectorAll('input').forEach(function (input) { input.checked = input.value === current.options[i]; });
        });
      }
      if (fieldsets.length) update(false);
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', function () { update(true); }); });

    // Quantity steppers
    root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
        input.value = next;
      });
    });

    // Mobile gallery dots
    if (mediaList && dots.length) {
      mediaList.addEventListener('scroll', function () {
        var idx = Math.round(mediaList.scrollLeft / mediaList.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === Math.abs(idx)); });
      }, { passive: true });
    }

    // Size guide dialog
    root.querySelectorAll('[data-dialog-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var dlg = document.getElementById(b.dataset.dialogOpen);
        if (dlg && dlg.showModal) dlg.showModal();
      });
    });

    // Add to cart
    if (form && useDrawer()) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        if (errorEl) errorEl.hidden = true;
        addBtn.setAttribute('aria-busy', 'true');
        addBtn.disabled = true;
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer');
        fd.append('sections_url', window.location.pathname);
        fetch(A.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) {
              if (errorEl) { errorEl.textContent = data.description || data.message; errorEl.hidden = false; }
              return;
            }
            if (data.sections) renderDrawer(data.sections['cart-drawer']);
            openDrawer('CartDrawer');
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            addBtn.removeAttribute('aria-busy');
            var v = variants.find(function (x) { return String(x.id) === String(idInput.value); });
            addBtn.disabled = v ? !v.available : false;
          });
      });
    }
  });

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    var load = function () {
      fetch(el.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '400px' });
      io.observe(el);
    } else { load(); }
  });
})();
